import {
  ROUTE_GROUP_SHORTCUTS,
  ROUTE_GROUP_SHORTCUTS_ADD,
  ROUTE_GROUP_SHORTCUTS_EDIT,
  ROUTE_GROUP_SHORTCUTS_USER,
  ROUTE_GROUP_SHORTCUTS_USER_ADD,
  ROUTE_GROUP_SHORTCUTS_USER_EDIT,
  ROUTE_GROUP_SHORTCUTS_USERS,
  ROUTE_GROUP_V2,
  ROUTE_GROUPS,
  ROUTE_HELP,
  ROUTE_MANAGEMENT,
  ROUTE_MANAGEMENT_TEAMS,
  ROUTE_MANAGEMENT_IMAGE_LOGIN,
  ROUTE_PROFILE,
  ROUTE_SESSION_EXPIRED,
  ROUTE_SHORTCUTS,
  ROUTE_SHORTCUTS_ADD,
  ROUTE_SHORTCUTS_EDIT,
  ROUTE_SHORTCUTS_FAMILY,
  ROUTE_STUDENT_DETAIL_V2,
  ROUTE_STUDENT_BROWSER_HISTORY,
  ROUTE_STUDENT_BROWSER_HISTORY_BY_DOMAIN,
  ROUTE_SUBSTITUTES,
  ROUTE_SUBSTITUTES_ADD,
  ROUTE_SUBSTITUTES_EDIT,
  ROUTE_TASKS,
  ROUTE_TASKS_ADD,
  ROUTE_TASKS_COPY,
  ROUTE_TASKS_DETAILS,
  ROUTE_TASKS_EDIT,
  ROUTE_TASKS_V2,
  ROUTE_TASKS_V2_DETAILS,
  ROUTE_TASKS_V2_ADD,
  ROUTE_TASKS_V2_EDIT,
  ROUTE_TASKS_V2_COPY,
} from './constants'
import SessionExpired from '../pages/SessionExpired/SessionExpired'
import { Route, Routes } from 'react-router-dom'
import AppLayout from '../components/AppLayout/AppLayout'
import { lazy } from 'react'
import RequireAuth from './RequireAuth'
import {
  MODULE_DASHBOARD,
  MODULE_GROUPS,
  MODULE_HELP,
  MODULE_SUBSTITUTES,
  MODULE_TASKS,
  MODULE_TASKS_V2,
  MODULE_REMOTE_VIEW,
  MODULE_TEAMS_MANAGEMENT,
} from '../../constants'
import { PERSON_TYPES_BROWSER_HISTORY, PERSON_TYPES_MANAGEMENT, PERSON_TYPES_TASKS } from '../constants'
import GroupSubscribe from '../pages/GroupV2/GroupSubscribe'

const Shortcuts = lazy(() => import('../pages/Shortcuts/Shortcuts'))
const ShortcutsFamily = lazy(() => import('../pages/Shortcuts/ShortcutsFamily/ShortcutsFamily'))
const Tasks = lazy(() => import('../pages/Tasks/Tasks'))
const TasksDetails = lazy(() => import('../pages/Tasks/TasksDetails'))
const TasksAdd = lazy(() => import('../pages/Tasks/Add/TasksAdd'))
const TasksEdit = lazy(() => import('../pages/Tasks/Edit/TasksEdit'))
const TasksCopy = lazy(() => import('../pages/Tasks/Copy/TasksCopy'))
const TasksV2 = lazy(() => import('../pages/TasksV2/Tasks'))
const TaskDetailsV2 = lazy(() => import('../pages/TasksV2/TaskDetails'))
const TaskAddV2 = lazy(() => import('../pages/TasksV2/TaskAdd'))
const TaskEditV2 = lazy(() => import('../pages/TasksV2/TaskEdit'))
const TaskCopyV2 = lazy(() => import('../pages/TasksV2/TaskCopy'))
const Groups = lazy(() => import('../pages/Groups/Groups'))
const Substitutes = lazy(() => import('../pages/Substitutes/Substitutes'))
const Help = lazy(() => import('../pages/Help/Help'))
const SubstitutesAdd = lazy(() => import('../pages/Substitutes/Add/SubstitutesAdd'))
const SubstitutesEdit = lazy(() => import('../pages/Substitutes/Edit/SubstitutesEdit'))
const GroupV2 = lazy(() => import('../pages/GroupV2/GroupV2'))
const GroupShortcuts = lazy(() => import('../pages/Shortcuts/Groups/Groups'))
const ShortcutsAdd = lazy(() => import('../pages/Shortcuts/Add/ShortcutsAdd'))
const ShortcutsEdit = lazy(() => import('../pages/Shortcuts/Edit/ShortcutsEdit'))
const GroupShortcutsAdd = lazy(() => import('../pages/Shortcuts/Groups/Add/GroupShortcutsAdd'))
const GroupShortcutsEdit = lazy(() => import('../pages/Shortcuts/Groups/Edit/GroupShortcutsEdit'))
const GroupUsersShortcuts = lazy(() => import('../pages/Shortcuts/Groups/GroupUsersShortcuts/GroupUsersShortcuts'))
const GroupUsersShortcutsEdit = lazy(() =>
  import('../pages/Shortcuts/Groups/GroupUsersShortcuts/Edit/GroupUsersShortcutsEdit')
)
const GroupUsersShortcutsAdd = lazy(() =>
  import('../pages/Shortcuts/Groups/GroupUsersShortcuts/Add/GroupUsersShortcutsAdd')
)
const StudentV2 = lazy(() => import('../pages/StudentV2/Student'))
const Profile = lazy(() => import('../pages/Profile/Profile'))
const Management = lazy(() => import('../pages/Management/Management'))
const ManagementTeams = lazy(() => import('../pages/Management/Teams/ManagementTeams'))
const ManagementImageLogin = lazy(() => import('../pages/Management/ImageLogin/ImageLogin'))
const BrowserHistory = lazy(() => import('../pages/BrowserHistory/BrowserHistory'))
const BrowserHistoryByDomain = lazy(() => import('../pages/BrowserHistory/BrowserHistoryByDomain'))

const PortalRoutes = () => (
  <Routes>
    <Route path={ROUTE_SESSION_EXPIRED} element={<SessionExpired />} exact />
    <Route element={<AppLayout />}>
      <Route
        exact
        path="/"
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <Shortcuts />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_SHORTCUTS}
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <Shortcuts />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_SHORTCUTS_ADD}
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <ShortcutsAdd />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_SHORTCUTS_FAMILY}
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <ShortcutsFamily />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_SHORTCUTS_EDIT}
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <ShortcutsEdit />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_GROUP_SHORTCUTS_USERS}
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <GroupUsersShortcuts />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_GROUP_SHORTCUTS_USER}
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <GroupUsersShortcuts />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_GROUP_SHORTCUTS_USER_EDIT}
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <GroupUsersShortcutsEdit />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_GROUP_SHORTCUTS_USER_ADD}
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <GroupUsersShortcutsAdd />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS}
        element={
          <RequireAuth module={MODULE_TASKS}>
            <Tasks />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS_DETAILS}
        element={
          <RequireAuth module={MODULE_TASKS}>
            <TasksDetails />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS_ADD}
        element={
          <RequireAuth module={MODULE_TASKS}>
            <TasksAdd />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS_EDIT}
        element={
          <RequireAuth module={MODULE_TASKS}>
            <TasksEdit />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS_COPY}
        element={
          <RequireAuth module={MODULE_TASKS}>
            <TasksCopy />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS_V2}
        element={
          <RequireAuth module={MODULE_TASKS_V2}>
            <TasksV2 />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS_V2_DETAILS}
        element={
          <RequireAuth module={MODULE_TASKS_V2}>
            <TaskDetailsV2 />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS_V2_ADD}
        element={
          <RequireAuth module={MODULE_TASKS_V2} personTypes={PERSON_TYPES_TASKS}>
            <TaskAddV2 />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS_V2_EDIT}
        element={
          <RequireAuth module={MODULE_TASKS_V2} personTypes={PERSON_TYPES_TASKS}>
            <TaskEditV2 />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_TASKS_V2_COPY}
        element={
          <RequireAuth module={MODULE_TASKS_V2} personTypes={PERSON_TYPES_TASKS}>
            <TaskCopyV2 />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_GROUPS}
        element={
          <RequireAuth module={MODULE_GROUPS}>
            <Groups />
          </RequireAuth>
        }
      />
      <Route path="groups2" element={<GroupSubscribe />}>
        <Route
          exact
          path={ROUTE_GROUP_V2}
          element={
            <RequireAuth module={MODULE_GROUPS}>
              <GroupV2 />
            </RequireAuth>
          }
        />
        <Route
          exact
          path={ROUTE_STUDENT_DETAIL_V2}
          element={
            <RequireAuth module={MODULE_GROUPS}>
              <StudentV2 />
            </RequireAuth>
          }
        />
      </Route>
      <Route
        exact
        path={ROUTE_STUDENT_BROWSER_HISTORY}
        element={
          <RequireAuth module={MODULE_REMOTE_VIEW} personTypes={PERSON_TYPES_BROWSER_HISTORY}>
            <BrowserHistory />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_STUDENT_BROWSER_HISTORY_BY_DOMAIN}
        element={
          <RequireAuth module={MODULE_REMOTE_VIEW} personTypes={PERSON_TYPES_BROWSER_HISTORY}>
            <BrowserHistoryByDomain />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_GROUP_SHORTCUTS}
        element={
          <RequireAuth module={MODULE_GROUPS}>
            <GroupShortcuts />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_GROUP_SHORTCUTS_ADD}
        element={
          <RequireAuth module={MODULE_GROUPS}>
            <GroupShortcutsAdd />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_GROUP_SHORTCUTS_EDIT}
        element={
          <RequireAuth module={MODULE_GROUPS}>
            <GroupShortcutsEdit />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_SUBSTITUTES}
        element={
          <RequireAuth module={MODULE_SUBSTITUTES}>
            <Substitutes />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_SUBSTITUTES_ADD}
        element={
          <RequireAuth module={MODULE_SUBSTITUTES}>
            <SubstitutesAdd />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_SUBSTITUTES_EDIT}
        element={
          <RequireAuth module={MODULE_SUBSTITUTES}>
            <SubstitutesEdit />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_HELP}
        element={
          <RequireAuth module={MODULE_HELP}>
            <Help />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_PROFILE}
        element={
          <RequireAuth module={MODULE_DASHBOARD}>
            <Profile />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_MANAGEMENT}
        element={
          <RequireAuth personTypes={PERSON_TYPES_MANAGEMENT}>
            <Management />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_MANAGEMENT_TEAMS}
        element={
          <RequireAuth module={MODULE_TEAMS_MANAGEMENT}>
            <ManagementTeams />
          </RequireAuth>
        }
      />
      <Route
        exact
        path={ROUTE_MANAGEMENT_IMAGE_LOGIN}
        element={
          <RequireAuth personTypes={PERSON_TYPES_MANAGEMENT}>
            <ManagementImageLogin />
          </RequireAuth>
        }
      />
    </Route>
  </Routes>
)

export default PortalRoutes
